export const initialAbility = [
  {
    action: 'read',
    subject: 'Auth',
  },
  {
    action: 'read',
    subject: 'profile',
  },
]

export const _ = undefined
